export function round(price) {
  const base = 0.05
  const modulo = price % base
  if (modulo - (base / 2) < 0) 
    return Math.round((price - modulo) * 100) / 100
  else if(modulo - (base / 2) > 0)
    return Math.round((price - modulo + 0.05) * 100) /100
  else
    return price
}